import { Report } from 'shared'
import { useReportURLDependencies } from 'hooks/useReportURLDependencies'
import { Issue } from './types'
import { getReportID } from '../utils'
import { errorHandler } from '../../../../../../../../hooks/errorHandler'

export function toReportExternalLink(
  issue: Issue['reports'][number],
  deps: ReturnType<typeof useReportURLDependencies>
) {
  const {
    asphaltLot,
    concreteTest,
    concreteTestSet,
    dailyInspectionControlPoint,
    dailyInspectionInspection,
    dailyInspectionPunchList,
    lot,
  } = issue ?? {}
  let href
  if (asphaltLot) href = Report.AsphaltLot.toURL({ ...asphaltLot, ...deps })
  else if (concreteTest)
    href = Report.ConcreteCylinderIASheet.toURL({ ...concreteTest, ...deps })
  else if (concreteTestSet)
    href = Report.ConcreteTestSet.toURL({ ...concreteTestSet, ...deps })
  else if (dailyInspectionControlPoint)
    href = Report.ControlPoint.toURL({
      ...dailyInspectionControlPoint,
      ...deps,
    })
  else if (dailyInspectionInspection)
    href = Report.Inspection.toURL({ ...dailyInspectionInspection, ...deps })
  else if (dailyInspectionPunchList)
    href = Report.PunchList.toURL({ ...dailyInspectionPunchList, ...deps })
  else if (lot) href = Report.DensityLot.toURL({ ...lot, ...deps })
  if (!href) throw errorHandler('href is not defined')
  const label = getReportID(issue)
  if (!label) throw errorHandler('label is not defined')
  return { label, href }
}
